(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["evaya-lineup-mobile"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initLineup(root) {
    if (root.dataset.elmInit) return;
    root.dataset.elmInit = "1";

    root.querySelectorAll(".elm-card").forEach(function (card) {
      var head = card.querySelector(".elm-rowhead");
      if (head) {
        head.addEventListener("click", function () {
          var open = card.classList.toggle("is-open");
          head.setAttribute("aria-expanded", String(open));
        });
      }

      var input = card.querySelector("[data-variant-input]");
      var priceEl = card.querySelector("[data-price]");
      var compareEl = card.querySelector("[data-compare]");

      card.querySelectorAll(".elm-chip").forEach(function (chip) {
        chip.addEventListener("click", function () {
          if (chip.hasAttribute("disabled")) return;
          card.querySelectorAll(".elm-chip").forEach(function (c) {
            c.classList.remove("is-active"); c.setAttribute("aria-pressed", "false");
          });
          chip.classList.add("is-active"); chip.setAttribute("aria-pressed", "true");
          if (input) input.value = chip.dataset.variantId;
          if (priceEl) priceEl.textContent = chip.dataset.price;
          var cmp = chip.dataset.compare || "";
          if (compareEl) { compareEl.textContent = cmp; compareEl.hidden = !cmp; }
        });
      });
    });
  }

  function boot() { document.querySelectorAll(".evaya-lineup-m").forEach(initLineup); }
  if (document.readyState !== "loading") boot(); else document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", function (e) {
    var el = e.target.querySelector(".evaya-lineup-m");
    if (el) initLineup(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["evaya-lineup-preview"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initLineup(root) {
    if (root.dataset.elInit) return;
    root.dataset.elInit = "1";

    var rail = root.querySelector(".el-rail");
    var prev = root.querySelector(".el-prev");
    var next = root.querySelector(".el-next");

    // Scroll arrows
    if (rail && prev && next) {
      function updateArrows() {
        prev.classList.toggle("is-hidden", rail.scrollLeft <= 4);
        next.classList.toggle("is-hidden", rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4);
      }
      function nudge(dir) {
        var card = rail.querySelector(".el-card");
        var step = card ? card.offsetWidth + 24 : rail.clientWidth * 0.8;
        rail.scrollBy({ left: dir * step, behavior: "smooth" });
      }
      prev.addEventListener("click", function () { nudge(-1); });
      next.addEventListener("click", function () { nudge(1); });
      rail.addEventListener("scroll", updateArrows, { passive: true });
      window.addEventListener("resize", updateArrows);
      updateArrows();
    }

    // Size chips → update variant + price
    root.querySelectorAll(".el-card").forEach(function (card) {
      var input = card.querySelector("[data-variant-input]");
      var priceEl = card.querySelector("[data-price]");
      var compareEl = card.querySelector("[data-compare]");
      var saveEl = card.querySelector("[data-save]");

      card.querySelectorAll(".el-chip").forEach(function (chip) {
        chip.addEventListener("click", function () {
          if (chip.hasAttribute("disabled")) return;
          card.querySelectorAll(".el-chip").forEach(function (c) {
            c.classList.remove("is-active");
            c.setAttribute("aria-pressed", "false");
          });
          chip.classList.add("is-active");
          chip.setAttribute("aria-pressed", "true");
          if (input) input.value = chip.dataset.variantId;
          if (priceEl) priceEl.textContent = chip.dataset.price;
          var cmp = chip.dataset.compare || "";
          if (compareEl) {
            compareEl.textContent = cmp;
            compareEl.hidden = !cmp;
          }
          if (saveEl) saveEl.style.display = cmp ? "" : "none";
        });
      });

      // Mobile "Details" toggle
      var more = card.querySelector(".el-more");
      if (more) {
        more.addEventListener("click", function () {
          var open = card.classList.toggle("is-open");
          more.setAttribute("aria-expanded", String(open));
          more.textContent = open ? "Less" : "Details";
        });
      }
    });
  }

  function boot() { document.querySelectorAll(".evaya-lineup").forEach(initLineup); }
  if (document.readyState !== "loading") boot(); else document.addEventListener("DOMContentLoaded", boot);
  // Theme-editor re-render support
  document.addEventListener("shopify:section:load", function (e) {
    var el = e.target.querySelector(".evaya-lineup");
    if (el) initLineup(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["evaya-lineup"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initLineup(root) {
    if (root.dataset.elInit) return;
    root.dataset.elInit = "1";

    var rail = root.querySelector(".el-rail");
    var prev = root.querySelector(".el-prev");
    var next = root.querySelector(".el-next");

    // Scroll arrows
    if (rail && prev && next) {
      function updateArrows() {
        prev.classList.toggle("is-hidden", rail.scrollLeft <= 4);
        next.classList.toggle("is-hidden", rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4);
      }
      function nudge(dir) {
        var card = rail.querySelector(".el-card");
        var step = card ? card.offsetWidth + 24 : rail.clientWidth * 0.8;
        rail.scrollBy({ left: dir * step, behavior: "smooth" });
      }
      prev.addEventListener("click", function () { nudge(-1); });
      next.addEventListener("click", function () { nudge(1); });
      rail.addEventListener("scroll", updateArrows, { passive: true });
      window.addEventListener("resize", updateArrows);
      updateArrows();
    }

    // Size chips → update variant + price
    root.querySelectorAll(".el-card").forEach(function (card) {
      var input = card.querySelector("[data-variant-input]");
      var priceEl = card.querySelector("[data-price]");
      var compareEl = card.querySelector("[data-compare]");
      var saveEl = card.querySelector("[data-save]");

      card.querySelectorAll(".el-chip").forEach(function (chip) {
        chip.addEventListener("click", function () {
          if (chip.hasAttribute("disabled")) return;
          card.querySelectorAll(".el-chip").forEach(function (c) {
            c.classList.remove("is-active");
            c.setAttribute("aria-pressed", "false");
          });
          chip.classList.add("is-active");
          chip.setAttribute("aria-pressed", "true");
          if (input) input.value = chip.dataset.variantId;
          if (priceEl) priceEl.textContent = chip.dataset.price;
          var cmp = chip.dataset.compare || "";
          if (compareEl) {
            compareEl.textContent = cmp;
            compareEl.hidden = !cmp;
          }
          if (saveEl) saveEl.style.display = cmp ? "" : "none";
        });
      });

      // Mobile "Details" toggle
      var more = card.querySelector(".el-more");
      if (more) {
        more.addEventListener("click", function () {
          var open = card.classList.toggle("is-open");
          more.setAttribute("aria-expanded", String(open));
          more.textContent = open ? "Less" : "Details";
        });
      }
    });
  }

  function boot() { document.querySelectorAll(".evaya-lineup").forEach(initLineup); }
  if (document.readyState !== "loading") boot(); else document.addEventListener("DOMContentLoaded", boot);
  // Theme-editor re-render support
  document.addEventListener("shopify:section:load", function (e) {
    var el = e.target.querySelector(".evaya-lineup");
    if (el) initLineup(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-construction"]) return;
  try {
    
document.querySelectorAll('.evaya-anatomy .ea-stack').forEach(function(stack){
  stack.querySelectorAll('.ea-band').forEach(function(row){
    row.addEventListener('click', function(){
      var was = row.classList.contains('open');
      stack.querySelectorAll('.ea-band').forEach(function(r){ r.classList.remove('open'); });
      if(!was){ row.classList.add('open'); }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
